import React from "react";
import {fetchNewsItem} from "../reducers/news";
import SeoComponent from "../common/SeoComponent";
import LayoutComponent from "../common/LayoutComponent";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {getByAlias} from '../selectors/common';
import {Link, Route, Switch} from "react-router-dom";
import NotFound from "./NotFound";
import Api from "../Api";
import $ from "jquery";
import {t} from "../IntManager";

if(!process.env.SSR) {
    require('lazysizes');
}

class NewsItem extends SeoComponent {
    static fetchData(store, params) {
        return store.dispatch(fetchNewsItem(params.alias));
    }

    componentDidMount() {
        if (this.props.newsItem === null) {
            this.props.fetchNewsItem(this.props.match.params.alias);
        }
    }

    onChangePageAnimation(e, url) {
        // e.preventDefault();
        $('html,body').scrollTop(0);
        // this.setState({redirect: url});
    }

    renderRelated() {
        const related = [];

        if (this.props.newsItem.lastNews) {
            for (let i in this.props.newsItem.lastNews) {
                if (this.props.newsItem.lastNews.hasOwnProperty(i)) {
                    const url = `/news/${this.props.newsItem.lastNews[i]['alias']}`;
                    related.push(
                        <React.Fragment key={i}>
                            <Link className="related__item" to={url} onClick={(e) => this.onChangePageAnimation(e, url)}>
                                <div className="news__cover relative">
                                    <img data-src={Api.getImage(this.props.newsItem.lastNews[i]['image'])}
                                         alt={this.props.newsItem.lastNews[i]['title']}
                                         className="news__image lazyload"/>
                                </div>
                                <div className="news__desc relative">
                                    <div className="news__date">{this.props.newsItem.lastNews[i]['datetime']}</div>
                                    <h3 className="news__title u-bold">{this.props.newsItem.lastNews[i]['title']}</h3>
                                    <span className="news__btn u-absolute">
                                        <span className="u-block u-absolute u-overflow-h slider-arrow__base">
                                            <span
                                                className="slider-arrow__circle u-absolute u-pos-tl u-fit u-block u-overflow-h"/>
                                        </span>
                                        <span className="slider-arrow__inner u-pos-tl u-absolute u-fit u-block">
                                            <span className="slider-arrow__icon u-absolute u-overflow-h u-block">
                                                <span className="slider-arrow__bar u-absolute u-inline-block"/>
                                                <svg className="slider-arrow__triangle u-absolute u-block u-pos-tl">
                                                    <use xlinkHref="/static/media/svg-symbols.svg#triangle-right"/>
                                                </svg>
                                            </span>
                                        </span>
                                    </span>
                                </div>
                            </Link>
                        </React.Fragment>
                    )
                }
            }

            return <React.Fragment>{related}</React.Fragment>
        }
    }

    render() {
        let content;
        if (this.props.notFound) {
            return <Switch>
                <Route component={NotFound}/>
            </Switch>
        } else if (this.props.error) {
            content = <div>Не удалось получить данные с сервера</div>
        } else if (this.props.loading || this.props.newsItem === null) {
            content = <div className="preloader">
                <div className="preloader__content relative">
                    <hr/>
                    <hr/>
                    <hr/>
                    <hr/>
                </div>
            </div>
        } else {
            this.setMetaTags(this.props.newsItem.title);
            content = <div>
                <div className="shell">
                    <div className="row">
                        <div className="col-xs-12 col-sm-10 col-sm-offset-1">
                            <div className="section__header">
                                <p className="new-item__date">{this.props.newsItem.datetime}</p>
                                <h2 className="u-bold">{this.props.newsItem.title}</h2>
                                <p className="new-item__post" dangerouslySetInnerHTML={{__html: this.props.newsItem.description}}></p>
                            </div>
                        </div>
                    </div>
                </div>
                <img data-src={Api.getImage(this.props.newsItem.image)} alt="" className="new-item__image lazyload"/>
                <div className="shell">
                    <div className="row">
                        <div className="col-xs-12">
                            <h2 className="section-desc__title u-bold">{t('read_also')}</h2>
                            <div className="related">
                                {this.renderRelated()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>;
        }

        return <LayoutComponent navReverse routerMatch={this.props.match}>
            <div className="news u-white-background">
                {content}
            </div>
        </LayoutComponent>
    }
}

const mapStateToProps = (state, props) => {
    return {
        newsItem: getByAlias(state.news.items, props.match.params.alias),
        error: state.news.error,
        loading: state.news.loading,
        notFound: state.news.notFound
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({fetchNewsItem}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(NewsItem);


// WEBPACK FOOTER //
// ./src/js/components/NewsItem.js